import { Rout_replace, Rout_to } from './Rout'
import { Rout_create } from './Rout.create'

export interface Rout_SearchRoutesArgs {
    Srch_Page: React.FunctionComponent<unknown>
}

export const Rout_SearchRoutes = (args: Rout_SearchRoutesArgs) => [
    // Stop prettier putting this on one line
    Rout_create('/search', args.Srch_Page),
]

export function Rout_toSearch() {
    Rout_to(`/search`)
}

export function Rout_replaceToSearch() {
    Rout_replace(`/search`)
}
